/**
 * Window Resizer — resize the browser to emulate device resolutions
 *
 * Declares one web-accessible-resource group covering assets/tpl/* and assets/fonts/*,
 * matched to every http(s) origin with no `use_dynamic_url` — so its tooltip templates
 * and bundled Lato fonts are fetchable from any page at a fixed URL.
 *
 * It ships no exposed icon images, so the primary signal is the vendor-named tooltip
 * stylesheet fetched with `probeFetch`. A successful read is conclusive — the resource
 * is served only when the extension is installed.
 *
 * Manifest verified against version 2.7.0.2169.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'kkelicaakdanhinjdeammmilcgefonfh';

export const windowResizer: ExtensionDefinition = {
  id: ID,
  name: 'Window Resizer',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 700_000,
  notes:
    'assets/tpl/* and assets/fonts/* exposed to every http(s) origin with no dynamic ' +
    'URL. No exposed images, so detection is a fetch of the vendor-named tooltip files.',
  signals: [
    {
      id: 'war-resize-tooltip-css',
      kind: 'web-accessible-resource',
      description:
        'Fetch assets/tpl/resize-tooltip.css — a vendor-named stylesheet for the resize ' +
        'tooltip, exposed to every origin.',
      weight: 1,
      run: () => probeFetch(ID, 'assets/tpl/resize-tooltip.css'),
    },
    {
      id: 'war-resize-tooltip-html',
      kind: 'web-accessible-resource',
      description:
        'Fetch assets/tpl/resize-tooltip.html — the matching tooltip template, a second ' +
        'distinctive path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'assets/tpl/resize-tooltip.html'),
    },
    {
      id: 'war-lato-black-font',
      kind: 'web-accessible-resource',
      description:
        'Fetch assets/fonts/lato-black.ttf — a bundled font from the second WAR entry, ' +
        'independent of the tooltip paths.',
      weight: 0.5,
      run: () => probeFetch(ID, 'assets/fonts/lato-black.ttf'),
    },
  ],
};
